import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import * as Sentry from "@sentry/react";

import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  .mapboxgl-ctrl-logo, .mapboxgl-ctrl-attrib {
    display: none !important;
  }
`;

Sentry.init({
  dsn: import.meta.env.VITE_APP_SENTRY,
  sendDefaultPii: true
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <BrowserRouter>
      <Toaster />
      <GlobalStyle />
      <App />
    </BrowserRouter>
  </Provider>
);
